
import styled from "styled-components";

const StyledErrorPage = styled.div`
    justify-content: center;
    margin: auto;
    text-align: center;
`;

export default StyledErrorPage;
